import { render, staticRenderFns } from "./quickReplies.vue?vue&type=template&id=510fb4f9&"
import script from "./quickReplies.vue?vue&type=script&lang=ts&"
export * from "./quickReplies.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports